
const Portfolio = () => {
  return (
    <iframe 
  src="/portfolio_work.pdf" 
  width="100%" 
  height="600px" 
  title="PDF Viewer">
</iframe>
  );
};

export default Portfolio;
